import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "172.093",
  height: "172.094",
  viewBox: "0 0 172.093 172.094"
}
const _hoisted_2 = { transform: "translate(-3111.166 -1034.585)" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "84.544",
  cy: "84.544",
  r: "84.544",
  transform: "translate(3112.67 1036.085)",
  fill: "#fff"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M84.544-1.5A86.672,86.672,0,0,1,101.884.248,85.582,85.582,0,0,1,132.654,13.2a86.291,86.291,0,0,1,31.173,37.856,85.622,85.622,0,0,1,5.014,16.153,86.869,86.869,0,0,1,0,34.679,85.582,85.582,0,0,1-12.948,30.77,86.291,86.291,0,0,1-37.856,31.173,85.622,85.622,0,0,1-16.153,5.014,86.869,86.869,0,0,1-34.679,0,85.582,85.582,0,0,1-30.77-12.948A86.291,86.291,0,0,1,5.262,118.037,85.622,85.622,0,0,1,.248,101.884a86.869,86.869,0,0,1,0-34.679A85.582,85.582,0,0,1,13.2,36.435,86.291,86.291,0,0,1,51.052,5.262,85.622,85.622,0,0,1,67.205.248,86.672,86.672,0,0,1,84.544-1.5Zm0,169.089a83.667,83.667,0,0,0,16.738-1.687,82.581,82.581,0,0,0,29.692-12.495,83.291,83.291,0,0,0,30.089-36.538,82.614,82.614,0,0,0,4.838-15.586,83.869,83.869,0,0,0,0-33.476,82.581,82.581,0,0,0-12.495-29.692A83.291,83.291,0,0,0,116.868,8.025a82.614,82.614,0,0,0-15.586-4.838,83.869,83.869,0,0,0-33.476,0A82.581,82.581,0,0,0,38.115,15.682,83.291,83.291,0,0,0,8.025,52.22,82.614,82.614,0,0,0,3.187,67.806a83.869,83.869,0,0,0,0,33.476,82.581,82.581,0,0,0,12.495,29.692A83.291,83.291,0,0,0,52.22,161.063,82.614,82.614,0,0,0,67.806,165.9,83.667,83.667,0,0,0,84.544,167.589Z",
  transform: "translate(3112.67 1036.085)",
  fill: "#303336"
}, null, -1)
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3112.97,1103.05l1.883,1.193a172.321,172.321,0,0,0,37.538,17.7,195.216,195.216,0,0,0,43.851,9.162c6.157.571,12.382.861,18.5.861a189.738,189.738,0,0,0,34.84-3.187,169.829,169.829,0,0,0,31.6-9.092l2.07-.826-.014,2.228c-.016,2.693-.131,5.145-.349,7.5a85.626,85.626,0,0,1-17.313,44.317,86.182,86.182,0,0,1-68.263,33.78c-2.67,0-5.379-.126-8.052-.374a86.679,86.679,0,0,1-17.1-3.343,85.587,85.587,0,0,1-29.442-15.736,86.3,86.3,0,0,1-27.541-40.575,85.626,85.626,0,0,1-3.5-16.548,86.685,86.685,0,0,1-.138-17.427c.218-2.343.557-4.774,1.037-7.432Zm101.773,31.913c-6.211,0-12.529-.294-18.778-.874a198.213,198.213,0,0,1-44.525-9.3,176.1,176.1,0,0,1-36.283-16.817c-.274,1.74-.482,3.386-.631,4.986a83.668,83.668,0,0,0,.133,16.822,82.588,82.588,0,0,0,9.7,30.72,83.292,83.292,0,0,0,33.6,33.338,82.613,82.613,0,0,0,15.072,6.258,83.673,83.673,0,0,0,16.51,3.227c2.581.24,5.2.361,7.775.361a82.965,82.965,0,0,0,82.589-75.374c.149-1.605.248-3.262.3-5.018a173.684,173.684,0,0,1-30.066,8.436A192.741,192.741,0,0,1,3214.743,1134.962Z",
  fill: "#303336"
}, null, -1)

import { withDefaults } from 'vue'

interface Props {
  fill: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GachaBall',
  props: {
    fill: { default: '#f9f247' }
  },
  setup(__props: any) {

const props = __props as { fill: string }

/**
 * GachaBall.
 *
 * ガチャボール.
 */



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("path", {
        d: "M3196.1,1132.595c-31.133-2.89-59.351-12.7-82.053-27.085-.433,2.4-.789,4.832-1.019,7.3a84.544,84.544,0,0,0,168.365,15.629c.23-2.474.328-4.929.343-7.368C3256.779,1131.034,3227.237,1135.484,3196.1,1132.595Z",
        fill: __props.fill
      }, null, 8, _hoisted_5),
      _hoisted_6
    ])
  ]))
}
}

})